<template>
  <div class="none" :class="{ active: type === 'white' }">
    <div class="empty-box">
        <div class="image-empty-item">
            <img 
                 src="../../assets/home/training-empty.png"
                 alt="" />
            <span>暂无数据</span>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["type"],
};
</script>
<style lang="scss" scoped>
    .none {
        width: 100%;
        height: auto;
        float: left;
        padding-top: 100px;
        padding-bottom: 100px;
        background-color: #f4fafe;

        &.active {
            background-color: #fff;
        }

        .empty-box {
        /*    width: 100%;
            height: auto;
            float: left;
            text-align: center;*/

            .image-empty-item {
                /* display: inline-block;*/
               
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    font-weight: 400;
                    text-align: center;
                    color: #2c2c2c;

                img {
                    width: 150px;
                    height: 150px;
                }
            }
        }
    }
</style>
